import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IPreferredContactMethodResponse } from '../../static-data/models/preferred-contact-method.model';


export const loadPreferredContactMethods = createAction('[StaticData] Load PreferredContactMethods');

export const loadPreferredContactMethodsSuccess = createAction('[StaticData] Load PreferredContactMethods Success', props<{ response: IPreferredContactMethodResponse[] }>());

export const loadPreferredContactMethodsFailure = createAction(
  '[StaticData] Load PreferredContactMethods Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
